import { useEffect, useState } from 'react';

/**
 * Hook to safely handle hydration mismatches
 * Returns true only after hydration is complete
 */
export function useHydrationSafe() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return isHydrated;
}

/**
 * Hook that returns different values during SSR vs client
 * Prevents hydration mismatches for dynamic content
 */
export function useClientValue<T>(serverValue: T, clientValue: T): T {
  const isHydrated = useHydrationSafe();
  return isHydrated ? clientValue : serverValue;
}